import './Header.scss';
import headerLogo from './headerLogo.png';
import LanguageSelector from '../LanguageSelector';
import LoggedUser from '../loggedUser/LoggedUser';
import TokenExpirationMessage from '../tokenExpirationMessage/TokenExpirationMessage';
import useMain from '../../common/MainContext';

export default function Header(props) {
  const { loginData } = useMain();

  return (
    <header>
      <div className="main-header">
        <div className="logo-area">
          <img className="header-logo" src={headerLogo} alt="logo" />
        </div>

        <div className="loggedUser-and-languagePicker">
          {loginData && <LoggedUser />}

          <LanguageSelector
            languages={[
              { value: "en", text: "en" },
              { value: "de", text: "de" },
              { value: "hu", text: "hu" },
            ]}
          />
        </div>
      </div>

      <TokenExpirationMessage />

    </header>
  );
}
